import Feather from '@sysunite/react-feather'
import { store } from '~/Store'
import { Modal } from 'antd'
import { ContextMenu } from 'Components'
import { AppView, SpreadSheetView } from 'Model'
import * as Types from 'Types'
import ConfigNode from 'Model'
import { getAppViews, getNodeLabel, getProjectData } from 'Services/WeaverUtils'
import BaseTreeNode from './BaseTreeNode'
import { createNewItem, createRoot, ComplexLabel, getCurrentTimeInMillis, getIds, editDeleteCtxMenu, getUpdatedSearchParams } from './shared'
import { deleteView } from 'Actions/homeTree'
import { setCurrentItem, setOpenInConsole, setTabDisabled, setTableConfig } from 'Actions/explore'

getQueries = (props) ->
  { groupings } = getProjectData()
  allQueries = [await getCustomViews(props)..., groupings...]
  if allQueries.length is 0 then [createView] else allQueries

viewsRootTitle = (
  <ComplexLabel
    title="Views"
    url="settings/views/new"
    testId="create-view"
  />
)

export viewsRoot = createRoot(viewsRootTitle, Types.VIEWS, 'all_queries', getQueries, Types.USERMODES.SIMPLE)

getCustomViews = (props) ->
  views = await getAppViews()
  sorted = _.sortBy(views, (view) -> view.get('name')?.toLowerCase())
  sorted.map((v) -> viewTreeNode(v, props))

export createView = createNewItem('all_queries', 'view', Types.CREATE_VIEW)

export viewTreeNode = (view, props) ->
  label = view.get('name')
  {
    node: view
    key: view.id()
    path: "all_queries/#{ view.id() }"
    icon: view.get('type')
    type: Types.VIEW
    isLeaf: true
    title: (
      <ContextMenu actions={viewCtxMenu(props, view)}>
        <BaseTreeNode
          id={view.id()}
          testId="view-#{label}"
          label={label}
        />
      </ContextMenu>
    )
  }

editDelFns = editDeleteCtxMenu(
  'view',
  (props, node, { domEvent }) ->
    domEvent.stopPropagation()
    props.history.push("/#{ props.spaceId }/settings/views/#{ node.id() }")
  , (props, node) ->
    store.dispatch(deleteView(node.id()))
    await node.destroy()
)

viewCtxMenu = (props, view) ->
  editDelFns(props, view)
    .concat([{
      key: 'run-in-console'
      title: <span>Run <b>{ getNodeLabel(view) }</b> in the console</span>
      onClick: ({ domEvent }) ->
        domEvent.stopPropagation()
        query = view.get('query') || view.get('treeQuery')
        store.dispatch(setOpenInConsole(query))
      hidden: not props.devtoolsEnabled || view.type isnt Types.QUERY
    }])

onClickFnsMap = {
  ['GraphView']: (node, props) ->
    item = {
      type: Types.QUERY,
      data: { node.buildQueries()... },
      ranAt: getCurrentTimeInMillis()
    }
    store.dispatch(setCurrentItem(item))
    store.dispatch(setTabDisabled({ key: 'elements', disabled: false }))
    store.dispatch(setTabDisabled({ key: 'attributes', disabled: true }))
    params = getUpdatedSearchParams('tab', 'elements')
    { explore: { tabIsLocked }} = store.getState()
    props.history.push({ pathname: window.location.pathname, search: params }) unless tabIsLocked
  ['SpreadSheetView']: (node, props) ->
    { query } = node.buildQueries()
    ids = await getIds(query)
    store.dispatch(setTableConfig({
      type: Types.NODE,
      data: {
        query
        ids
      }
    }))
}

export default {
  [Types.CREATE_VIEW]: (view, { history, spaceId }) ->
    history.push("/#{ spaceId }/settings/views/new")
  [Types.VIEW]: ({ node }, props) ->
    { constructor: { className } } = node
    onClickFnsMap[className](node, props)
}
